export default "__VITE_ASSET__CX3PDN9c__"